import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=5f82fca0&scoped=true"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82fca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f82fca0')) {
      api.createRecord('5f82fca0', component.options)
    } else {
      api.reload('5f82fca0', component.options)
    }
    module.hot.accept("./CommentModal.vue?vue&type=template&id=5f82fca0&scoped=true", function () {
      api.rerender('5f82fca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/psyCalCultManage/PriorityCareStu/components/CommentModal.vue"
export default component.exports